/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import { createGetPromptVersionService } from '../../../../common/prompt/createPromptV2Services';
import * as constants from '../../constants/ServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/StudioTextConstants';

export default createGetPromptVersionService({
  eventName: constants.GET_PROMPT_VERSION,
  statusKey: 'getPromptVersionStatus',
  storeName: 'studioPromptModel',
  errorLangKey: PROMPT_MANAGEMENT_LANG_KEYS.ERROR_VERSION,
  errorEvent: constants.GET_PROMPT_VERSION_ERROR
});
